export default __webpack_public_path__ + "static/media/eurs.36f6e833.svg";